/**
 * Permission checks on the signed-in member's access level.
 *
 * The server sends the member's value for every permission (_ext.PERMISSIONS)
 * and each permission's values from most restrictive to least
 * (_ext.PERMISSION_VALUES), so "at least view" is a comparison of positions.
 * Anything unknown fails: a mistake must hide a screen, never open one.
 *
 * CommonJS so the node-backend logic tests can require it.
 */

function can(permissions, values, key, atLeast) {
    var min = atLeast === undefined ? 'yes' : atLeast;
    var list = values && values[key];
    if (!permissions || !list) return false;

    var minRank = list.indexOf(min);
    var rank = list.indexOf(permissions[key]);

    return minRank !== -1 && rank !== -1 && rank >= minRank;
}

module.exports = {
    can: can,
};
